import React from 'react';
import styles from './CardItemEstoque.module.css';

const CardItemEstoque = ({ produto, getStatus, getStatusClass }) => {
  return (
    <div className={styles.stockItem}>
      <div className={styles.itemInfo}>
        <div className={styles.itemIcon}>
          <img src={produto.imagem} alt={produto.nome_item} />
        </div>
        <div className={styles.itemDetails}>
        <span className={styles.nomeItem}>
          {produto.nome_item.split(' ').slice(0, 5).join(' ')}
        </span>
          <div className={styles.itemInfoDetails}>
            {produto.quantidade === null || produto.quantidade === undefined ? (
              <span>Estoque ilimitado</span>
            ) : (
              <>
                <span>Restam: {produto.quantidade}</span> • <span>Mín.: {produto.quantidade_minima}</span>
              </>
            )}
          </div>
        </div>
      </div>
      <button className={`${styles.statusBtn} ${styles[getStatusClass(produto)]}`}>
        {getStatus(produto)}
      </button>
    </div>
  );
};

export default CardItemEstoque;
